import { TFunction } from 'i18next';

import { TValidator } from './types';

export const MAX_CHARS_KEY = 'validation.maxLength';

export const handleMaxCharsError = (errorMessage: string, t: TFunction, characters: number) => {
  if (errorMessage === MAX_CHARS_KEY) {
    return t(errorMessage, { characters });
  }

  return t(errorMessage);
};

export const maxChars =
  (chars: number): TValidator =>
  (value: string) =>
    value && value.length > chars ? MAX_CHARS_KEY : undefined;
